import { useCallback } from 'react';
import { useOpgavekompleksetComponent } from '../context.data.js';
import { useCurrentTaskEntryId } from '../hook.entry.js';
import { useGoToTaskMutation } from '../mutations/task.go-to.js';

function useGoToPreviousTaskAction() {
  const component = useOpgavekompleksetComponent();
  const activeTaskId = useCurrentTaskEntryId();
  const goToTaskMutation = useGoToTaskMutation();
  return useCallback(async () => {
    const currentTaskIndex = component.data.tasks.findIndex(it => it.id === activeTaskId);
    const prevTaskIndex = currentTaskIndex - 1;
    const prevTask = component.data.tasks[prevTaskIndex];
    if (prevTask) {
      goToTaskMutation(prevTask.id);
    }
  }, [activeTaskId, component.data.tasks, goToTaskMutation]);
}

export { useGoToPreviousTaskAction };
//# sourceMappingURL=task.go-to-prev.js.map
